"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInternalWebsiteBaseUrl = void 0;
Object.defineProperty(exports, "getInternalWebsitePath", {
  enumerable: true,
  get: function get() {
    return _whitelabelUtils.getInternalWebsitePath;
  }
});
exports.getPublicWebsiteBaseUrlFromSettings = exports.getPublicWebsiteBaseUrl = void 0;
Object.defineProperty(exports, "isBizzaboInternalWebsiteWhiteLabeled", {
  enumerable: true,
  get: function get() {
    return _whitelabelUtils.isBizzaboInternalWebsiteWhiteLabeled;
  }
});

var _whitelabelUtils = require("@bizzabo/whitelabel-utils");

var _config = _interopRequireDefault(require("config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Whitelabel utils injected with config */
var getInternalWebsiteBaseUrl = function getInternalWebsiteBaseUrl(event, path) {
  return (0, _whitelabelUtils.getInternalWebsiteBaseUrl)(event, _config.default.eventsUrl, path);
};

exports.getInternalWebsiteBaseUrl = getInternalWebsiteBaseUrl;

var getPublicWebsiteBaseUrl = function getPublicWebsiteBaseUrl(event, path) {
  return (0, _whitelabelUtils.getPublicWebsiteBaseUrl)(event, _config.default.eventsUrl, path);
};

exports.getPublicWebsiteBaseUrl = getPublicWebsiteBaseUrl;

var getPublicWebsiteBaseUrlFromSettings = function getPublicWebsiteBaseUrlFromSettings(websiteSettings) {
  return (0, _whitelabelUtils.getPublicWebsiteBaseUrlFromSettings)(websiteSettings, _config.default.eventsUrl);
};

exports.getPublicWebsiteBaseUrlFromSettings = getPublicWebsiteBaseUrlFromSettings;